import auth from "../middleware/auth";

const routes = [
  {
    path: "/training",
    name: "Training",
    component: () => import("../../views/protected/Training"),
    meta: {
      layout: () => import("../../layouts/protected"),
      middleware: [auth],
    },
  },
];

export default routes;
